import { ParamIds, Places } from '../../../Constants'
import IntegracaoMonitoramentoKeys from '../integracao-monitoramento.keys'

export class IntegracaoMonitoramentoFormKeys extends IntegracaoMonitoramentoKeys {
    get place() {
        return Places.integracaoMonitoramentoForm
    }

    get monitoramentoId() {
        return this._intent.getParameterAsNumber(ParamIds.monitoramentoFormId)
    }

    set monitoramentoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.monitoramentoFormId, value)
    }
}
